module.exports = __webpack_public_path__ + "static/media/912q5cQs6DL._SL1500_.09c47c0e.jpg";